import { AxiosError } from 'axios';
import { lowerFirst } from 'lodash';
import { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ValidationErrorResponse } from 'api/v1/data-contracts';

export const getValidationErrorMessage = (
	validationError: ValidationErrorResponse | undefined,
	fallbackMessage: string
): string => {
	const invalidItemMessage = validationError?.invalidItems?.find(
		(item) => typeof item.errorMessage === 'string' && item.errorMessage
	)?.errorMessage;

	if (invalidItemMessage) {
		return invalidItemMessage;
	}

	return fallbackMessage;
};

export const useFormError = <T extends FieldValues>(
	setError: UseFormSetError<T>
) => {
	const { t } = useTranslation(['common']);

	const setFormError = (error: AxiosError<ValidationErrorResponse>) => {
		const { response } = error;

		if (response?.data.invalidItems) {
			response.data.invalidItems.forEach(
				({ errorMessage, propertyName }) => {
					if (!!propertyName) {
						setError(lowerFirst(propertyName) as Path<T>, {
							type: 'custom',
							message:
								errorMessage || t('common:error-unexpected'),
						});
					}
				}
			);
		}
	};

	return { setFormError };
};
